import { getAdminLoginUrl } from '../config/proxySessionToken';

/**
 * Logowanie przez PHP (home.pl) — hasło nie przechodzi przez proxy Supabase z builda.
 */
export async function loginViaAdminPhp(email, password) {
  const url = getAdminLoginUrl();
  if (!url) {
    throw new Error('Brak REACT_APP_ADMIN_LOGIN_URL lub REACT_APP_SUPABASE_PROXY_URL');
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: email.toLowerCase().trim(),
      password: password.trim(),
    }),
  });

  const text = await response.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error('Nieprawidłowa odpowiedź serwera logowania');
  }

  if (!response.ok) {
    throw new Error(data?.error || 'Nieprawidłowy email lub hasło');
  }

  if (!data?.user?.id || !data?.token) {
    throw new Error('Nieprawidłowa odpowiedź logowania');
  }

  return {
    user: data.user,
    token: data.token,
    expiresAt: data.expiresAt || Date.now() + 7 * 24 * 60 * 60 * 1000,
  };
}
